"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstalledRelatedAppsInjector = void 0;
const react_1 = require("react");
const jotai_1 = require("jotai");
const atom_1 = require("../../../atom");
const InstalledRelatedAppsInjector = () => {
    const setInstalledRelatedApp = (0, jotai_1.useSetAtom)(atom_1.$InstalledRelatedApp);
    (0, react_1.useEffect)(() => {
        if (!('getInstalledRelatedApps' in navigator)) {
            setInstalledRelatedApp(null);
            return;
        }
        navigator.getInstalledRelatedApps()
            .then((apps) => apps.filter((app) => app.id?.includes('com.bd.nproject')))
            .then(([app]) => {
            if (!app) {
                setInstalledRelatedApp(null);
            }
            else {
                setInstalledRelatedApp(app);
            }
        })
            .catch((err) => {
            console.warn(err);
        });
    }, []);
    return null;
};
exports.InstalledRelatedAppsInjector = InstalledRelatedAppsInjector;
